import axios from "axios";
import { history } from "../utils/history";
import { toast } from "react-toastify";

axios.interceptors.response.use(null, (error) => {
  const expectedError =
    error.response &&
    error.response.status >= 400 &&
    error.response.status < 500;

  if (!expectedError) {
    toast.error("An unexpected error occured.");
  }

  // 401 = not authenticated → send to login. 403 = authenticated but not permitted; do NOT
  // log the user out (that produced a confusing re-login loop), just surface an access error.
  if (error.response.status === 401) {
    history.push("/login");
  } else if (error.response.status === 403) {
    toast.error("You don't have permission to perform that action.");
  }


  return Promise.reject(error);
});

function setJwt(jwt) {
  axios.defaults.headers.common["X-auth-token"] = jwt;
  axios.defaults.headers.common["Authorization"] = "Bearer " + jwt;
}

function setFormioJwt(jwt) {
  axios.defaults.headers.common["x-jwt-token"] = jwt;
}

const http = {
  get: axios.get,
  post: axios.post,
  put: axios.put,
  delete: axios.delete,
  setJwt,
  setFormioJwt,
};

export default http;
